import {PersonalInfoTypeModel} from '../model/personal-info-type.model';
import {ContactInfoTypeModel} from '../model/contact-info-type.model';

export class PersonalDetailModel {

    public personal: PersonalInfoTypeModel = new PersonalInfoTypeModel();
    public contact: ContactInfoTypeModel = new ContactInfoTypeModel();

}
